import './app.cjs'
